<template>
    <section class="xnax-login">
        <div class="login-rubies">
            <!--            <p class="login-intro">Enrollment</p>-->
            <p class="login-intro">OTP</p>
            <div class="login-form">
                <img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/rubies-logo.png" @click="goHome" alt="">

                <div>
                    <div v-if="alert.show" class="alert-box">
                        <div class="row">
                            <div class="col-sm-12">
                                <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                    {{alert.message}}
                                </ui-alert>
                            </div>
                        </div>
                    </div>

                    <div>
                        <p class="pageHeaderP">
                            We've sent a 4-digit confirmation code to
                            <b>{{mutableTotalRequestBody.phonenumber}}</b>
                            and <b>{{mutableTotalRequestBody.email}}</b>
                        </p>
                    </div>

                    <div class="row">
                        <div class="col-md-12 form-group mb-2">
                            <div class="otp">
                                <div class="otpBox">
                                    <input
                                            title="" v-model="otp[0]" autocomplete="off" name="venus"
                                            type="text" maxlength="1" autofocus :autocomplete="false"
                                            v-on:keypress="isNumber($event)" v-on:keyup="otpInputHandler($event)"
                                    >
                                    <input
                                            title="" v-model="otp[1]" autocomplete="off" name="venus"
                                            type="text" maxlength="1" autofocus :autocomplete="false"
                                            v-on:keypress="isNumber($event)" v-on:keyup="otpInputHandler($event)"
                                    >

                                    <span class="midMark">-</span>

                                    <input
                                            title="" v-model="otp[2]" autocomplete="off" name="venus"
                                            type="text" maxlength="1" autofocus :autocomplete="false"
                                            v-on:keypress="isNumber($event)" v-on:keyup="otpInputHandler($event)"
                                    >
                                    <input
                                            title="" v-model="otp[3]" autocomplete="off" name="venus"
                                            type="text" maxlength="1" autofocus :autocomplete="false"
                                            v-on:keypress="isNumber($event)" v-on:keyup="otpInputHandler($event)"
                                    >
                                </div>
                            </div>

                            <!--<p class="otp-resend">-->
                            <p class="pageHeaderP text-center">
                                If you didn't get an otp dial *7797*12#.
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'


    import {enrollmentEventBus} from "../../../main";


    export default {
        name: "stagefive",
        components: {},
        props: {
            totalRequestBody: {
                type: Object,
                default: {}
            },
        },
        data () {
            return {
                otp:[],
                otpsubmit: false,

                mutableTotalRequestBody: this.totalRequestBody,

                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getAppLoading',
                'startAppLoading',
                'stopAppLoading',
            ])
        },
        created () {},
        methods: {
            ...mapActions([
                'updateCurrentComponent',
                'updateEnrollComponent',
                'updateAppLoading',
                'updateDataOnLogin',
            ]),

            resetInputFields(){
                this.otp = [];
                this.otpsubmit= false;
            },
            isNumber (evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            maxlenght (e) {
                let target = e.srcElement || e.target;
                let maxLength = parseInt(target.attributes["maxlength"].value, 10);
                let myLength = target.value.length;
                if (myLength >= maxLength) {
                    let next = target;
                    while (next = next.nextElementSibling) {
                        if (next == null)
                            break;
                        if (next.tagName.toLowerCase() === "input") {
                            next.focus();
                            break;
                        }
                    }
                } else if (myLength === 0) {
                    // Move to previous field if empty (user pressed backspace)
                    let previous = target;
                    while (previous = previous.previousElementSibling) {
                        if (previous == null)
                            break;
                        if (previous.tagName.toLowerCase() === "input") {
                            previous.focus();
                            break;
                        }
                    }
                }
            },
            isAllOtpBoxFilled(){
                if (this.otp[0] && this.otp[1] && this.otp[2] && this.otp[3]){
                    //Consume Final Post API
                    this.completeEnrollment();
                }
            },
            otpInputHandler(e){
                this.maxlenght(e);
                this.isAllOtpBoxFilled()
            },

            completeEnrollment () {
                // this.otpsubmit = true;

                //start running
                this.updateAppLoading(true);

                let otp = this.otp[0]+this.otp[1]+this.otp[2]+this.otp[3];

                // console.log('mutableTotalRequestBody ==>>', this.mutableTotalRequestBody);

                // console.log(otp);


                let dataToBeSent = {
                    uniqueref: this.mutableTotalRequestBody.uniqueref,
                    createaccount: this.mutableTotalRequestBody.createaccount,
                    accountnumber: this.mutableTotalRequestBody.accountnumber ? this.mutableTotalRequestBody.accountnumber : '',
                    source: "WEB",
                    token: otp,
                    password: this.mutableTotalRequestBody.passcode,
                    pin: this.mutableTotalRequestBody.tpin
                }

                // console.log('Data To Be Sent ===>>', dataToBeSent);

                axios
                    .post('/enrolmentcomplete', dataToBeSent)
                    .then(response => {
                        //stop running
                        this.updateAppLoading(false)

                        let responseData = response.data;


                        if (responseData.responsecode === '00'){
                            let responseData = response.data;

                            // console.log('Account Opening Response ===>>', responseData);
                            // console.log('Account mutableTotalRequestBody ===>>', this.mutableTotalRequestBody);

                            this.alert.show = false;

                            //set dataOnLogin in the store to the login response
                            this.updateDataOnLogin(responseData);

                            // change the currentComponent in the store to 'dashboard'
                            this.updateCurrentComponent('inside')
                        }else {
                            //reset step 3 fields
                            this.resetInputFields()

                            // display error notification
                            this.showAlert(true, 'error', responseData.responsemessage)
                        }
                    })
                    .catch(error => {
                        //stop running
                        this.updateAppLoading(false)

                        //reset input fields
                        this.resetInputFields()

                        //reset step 4 fields
                        // console.log(error);

                        // display error notification
                        this.showAlert(true, 'error', 'Network Error')
                    })
            },

            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },
            goHome(){
                //Route to Login page
                this.$router.push('/');
            },
        },
    }
</script>

<style scoped>
    .checkbox-row{
        padding: 0;
        margin-bottom: 30px;
    }
    .checkbox-row .main-big{
        display: block;
        font-size: 16px;
        font-weight: 500;
        color: #171717;
    }
    .checkbox-row .sub-small{
        color: #570404;
        font-size: 10px;
        display: block;
        color: #6e6e6e;
    }
    .checkbox-container .checkbox-label {
        margin: 0 0 0 10px;
    }
    .login-rubies .alter-links a {
        text-align: center;
    }
    .no-pad{
        padding: 0!important;
    }

</style>